import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ProcessingOrders } from 'src/app/models/supplier-portal/supplier/supplierOrdersProcessing.models';

@Injectable({
  providedIn: 'root',
})
export class OrderHelperService {
  selectedProduct: BehaviorSubject<ProcessingOrders.IProductInOrder | null> = new BehaviorSubject(null);
  selectedBatch: BehaviorSubject<ProcessingOrders.IProductBatch | null> = new BehaviorSubject(null);
  selectedDocuments: BehaviorSubject<ProcessingOrders.IProductBatchDocument[] | []> = new BehaviorSubject([]);
  ddtDate: BehaviorSubject<string | null> = new BehaviorSubject(null);

  // get getRemainingQty() {
  //   const sum = this.selectedProduct.value.batches.reduce(
  //     (acc, lot) => acc + (lot.serial_to - lot.serial_from + 1),
  //     0
  //   );
  //   return this.selectedProduct.value.quantity - sum;
  // }

  private getBatchQuantity(lot: ProcessingOrders.IProductBatch | null | undefined): number {
    if (!lot) {
      return 0;
    }

    if (lot.manual_batch) {
      return lot.quantity ?? 0;
    }

    return (lot.serial_to ?? 0) - (lot.serial_from ?? 0) + 1;
  }

  get getRemainingQtyDuplicates() {
    const batches = this.selectedProduct.value?.batches ?? [];
    let sum = 0;

    for (const lot of batches) {
      sum += this.getBatchQuantity(lot);
    }

    return (this.selectedProduct.value?.quantity ?? 0) - sum;
  }

  get batchQty() {
    return this.getBatchQuantity(this.selectedBatch.value);
  }

  batchQtyCalculation(batches: ProcessingOrders.IProductBatch[] = []) {
    let sum = 0;

    for (const lot of batches) {
      sum += this.getBatchQuantity(lot);
    }

    return sum;
  }

  get getBatchMaximumQty() {
    return this.getRemainingQtyDuplicates + this.batchQty;
  }

  getIsPartial(article: ProcessingOrders.IProductInOrder, isCompleted: boolean = false) {
    const sum = this.batchQtyCalculation(article.batches ?? []);
    return sum == 0 && !isCompleted ? false : this.batchQtyCalculation(article.batches ?? []) < +article?.quantity;
  }


}
